<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path d="M9 2L3.5 2C2.39543 2 1.5 2.89543 1.5 4L1.5 12C1.5 13.1046 2.39543 14 3.5 14L9 14" stroke="var(--icon-color)" />
    <path d="M6 7.5L14.5 7.46049M14.5 7.46049L11.5 10.4746M14.5 7.46049L11.5 4.47461" stroke="var(--icon-color)" />
</svg>
